export default __webpack_public_path__ + "static/media/5_of_hearts.f407aa6f.png";